import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'eui-page-content',
    templateUrl: './eui-page-content.component.html',
    // changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiPageContentComponent {

    @HostBinding() class = 'eui-page-content';

    constructor (
    ) {}

}
